<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div [class.slds-has-error]="errorMsg"
     class="slds-form-element slds-has-error">
  <span [id]="theId + '-primary-label'"
        class="slds-form-element__label">{{ label }}</span>
  <div class="slds-form-element__control">
    <div class="slds-file-selector slds-file-selector_files">
      <div (dragover)="onDragOver($event)"
           (drop)="onDrop($event)"
           class="slds-file-selector__dropzone">
        <input (change)="onChange($event)"
               [accept]="accept"
               [attr.aria-describedby]="theId + '-error'"
               [attr.aria-labelledby]="theId + '-primary-label ' + theId + '-secondary-label'"
               [id]="theId"
               [readOnly]="readonly"
               capture="environment"
               class="slds-file-selector__input slds-assistive-text"
               type="file"/>
        <label [for]="theId"
               [id]="theId + '-secondary-label'"
               class="slds-file-selector__body">
          <span class="slds-file-selector__button slds-button slds-button_neutral"
                style="white-space: nowrap">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#upload"></use>
            </svg>
            {{ labelButton }}</span>
          <span class="slds-file-selector__text slds-medium-show">or Drop File</span>
        </label>
      </div>
      <div class="slds-m-around_x-small">
        <canvas #canvas style="display: none; margin: 5px 0"></canvas>
        <span class="slds-text-body_small">{{ fileName }}</span>
      </div>
    </div>
  </div>
  <div [id]="theId + '-error'" class="slds-form-element__help">{{errorMsg}}</div>
</div>
